export const getConceptChartOptions = (votesData) => ({
    animationEnabled: true,
    theme: "light2",
    title: {
        text: "Concepts Vote",
        fontFamily: "Chakra Petch",
        fontWeight: "600"
    },
    data: [{
        type: "pie",
        indexLabel: "{label}: {y}%",
        startAngle: -90,
        dataPoints: [
            { label: "Furicane", y: (100 * votesData[1] / Object.values(votesData).reduce((a, b) => a + b, 0)) },
            { label: "Amberclaw", y: (100 * votesData[2] / Object.values(votesData).reduce((a, b) => a + b, 0)) },
            { label: "Satoshisaurus", y: (100 * votesData[3] / Object.values(votesData).reduce((a, b) => a + b, 0)) },
            { label: "Bruce", y: (100 * votesData[4] / Object.values(votesData).reduce((a, b) => a + b, 0)) },
            { label: "Glitterrex", y: (100 * votesData[5] / Object.values(votesData).reduce((a, b) => a + b, 0)) }
        ]
    }]
});

export const getChainChartOptions = (chainData) => ({
    animationEnabled: true,
    theme: "light2",
    title: {
        text: "Chain Vote",
        fontFamily: "Chakra Petch",
        fontWeight: "600"
    },
    axisY: {
        title: "Number of Votes"
    },
    data: [{
        type: "column",
        dataPoints: [
            { label: "Arbi", y: chainData[1] },
            { label: "Optimism", y: chainData[2] },
            { label: "Base", y: chainData[3] },
            { label: "Linea", y: chainData[4] },
            { label: "Solana", y: chainData[5] },
            { label: "Zksync", y: chainData[6] },
            { label: "Mantle", y: chainData[7] },
            { label: "Mode", y: chainData[8] }
        ]
    }],
    axisX: {
        labelAngle: 0
    },
    creditText: null
});